export default {
  namespaced: true,
  getters: {
    permisosPresupuestos1(state, getters, rootState) {
      return (
        rootState.CARGO.id == 4 || // ADMINISTRADOR
        rootState.CARGO.id == 14 || // ENC CONTABILIDAD
        rootState.CARGO.id == 15 || // AUXILIAR CONTABLE
        rootState.CARGO.id == 19 || // ENCARGADO NACIONAL DE CONTABILIDAD
        rootState.CARGO.id == 21 || // SUPERVISORA ADMINISTRATIVO CONTABLE Y FINANCIERO
        rootState.CARGO.id == 24 || // ENC CONTABILIDAD PRESUPUESTOS (NUEVO ROL)
        rootState.CARGO.id == 27 || // CONTADOR EXTERNO (NUEVO ROL)
        rootState.CARGO.id == 1 // MASTER
      );
    },
    permisosPresupuestos2(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 1099 || // SILVIA PATRICIA VILLEGAS MENDOZA
        rootState.DATA_USER.id == 6457 || // HOMALY TEYBE ZAMORANO DURAN
        rootState.DATA_USER.id == 31 || // ANDREA ZUÑIGA YAÑEZ
        rootState.DATA_USER.id == 46812 || // MARIELA TORRES TORRES
        rootState.DATA_USER.id == 39718 || // LUIS FERNANDO SALGADO MIGUEZ
        rootState.DATA_USER.id == 52394 || // JHOMARA JAEL GALARZA CRUZ
        rootState.DATA_USER.id == 870 || // NATALY SORUCO SÁNCHEZ
        rootState.DATA_USER.id == 8920 || // FABIOLA AVILA RODRÍGUEZ
        rootState.DATA_USER.id == 54960 || // CAMILA MENDIVIL PAREDES
        rootState.DATA_USER.id == 89251 || // BAPTISTA ALBORNOZ ANDREA MILENKA
        rootState.DATA_USER.id == 9029 || // GARDILCIC FLORES DINKA RAHIZA
        rootState.CARGO.id == 1 // MASTER
      );
    },
    permisosPresupuestos3(state, getters, rootState) {
      return (
        rootState.CARGO.id == 26 // EJECUTIVO GESTIÓN EMPRESARIAL
      );
    },
  },
};
